import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/auth";

const WARN_AT = 5 * 60; // start the "wrap up" notice at 5 minutes left

// Shown app-wide ONLY for ephemeral session students: a gentle banner in the last 5 minutes,
// then an automatic sign-out when the class code expires.
export default function SessionTimer() {
  const { account, signOut } = useAuth();
  const navigate = useNavigate();
  const [remaining, setRemaining] = useState(null);
  const endedRef = useRef(false);

  const expiresAt = account?.is_session_student ? account?.session_expires_at : null;

  useEffect(() => {
    endedRef.current = false;
    if (!expiresAt) { setRemaining(null); return; }
    const tick = () => {
      const secs = Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000));
      setRemaining(secs);
      if (secs <= 0 && !endedRef.current) {
        endedRef.current = true;
        toast("Your class session has ended. See you next time! 👋");
        signOut();
        navigate("/onboarding");
      }
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [expiresAt, signOut, navigate]);

  if (remaining == null || remaining > WARN_AT || remaining <= 0) return null;
  const mmss = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, "0")}`;
  return (
    <div data-testid="session-expiry-banner" className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center bg-primary px-4 py-2 text-center text-sm font-semibold text-white shadow-lg">
      Class ends in {mmss} — wrap up and save anything important.
    </div>
  );
}
